import {createQueryKeys} from "../../shared/query/query-keys";

export const materialKeys = createQueryKeys("materials");

export const materialMutationKeys = {
  createMaterial: ["materials", "mutation", "createMaterial"] as const,
  updateMaterial: ["materials", "mutation", "updateMaterial"] as const,
  deleteMaterial: ["materials", "mutation", "deleteMaterial"] as const,
  restoreMaterial: ["materials", "mutation", "restoreMaterial"] as const,
  updateMaterialComposition: ["materials", "mutation", "updateMaterialComposition"] as const,
  addMaterialDescription: ["materials", "mutation", "addMaterialDescription"] as const,
  editMaterialDescription: ["materials", "mutation", "editMaterialDescription"] as const,
  addMaterialFunction: ["materials", "mutation", "addMaterialFunction"] as const,
  removeMaterialFunction: ["materials", "mutation", "removeMaterialFunction"] as const,
  addMaterialNote: ["materials", "mutation", "addMaterialNote"] as const,
  editMaterialNote: ["materials", "mutation", "editMaterialNote"] as const,
  removeMaterialNote: ["materials", "mutation", "removeMaterialNote"] as const,
};
